export const ERROR_CODES = {
    COUNTRY_IS_BLOCKED_BY_ORGANIZATION: 'COUNTRY_IS_BLOCKED_BY_ORGANIZATION',
    INVALID_DATA_FOR_CANDIDATE: 'INVALID_DATA_FOR_CANDIDATE'
};
